// src/constants/incidentContext.js

/**
 * Structured intake fields that travel from the submit form into the workspace
 * context rail. Kept in one place so the customer is not asked one shape of
 * question at intake and a different shape once the expert is already on the
 * call.
 */

export const CONTEXT_FIELDS = [
  {
    key: "environment",
    label: "Environment",
    placeholder: "e.g. production checkout, Next.js on Vercel, Stripe live mode",
    rows: 2,
    required: true,
  },
  {
    key: "broken",
    label: "Expected vs actual",
    placeholder: "What should happen, and what happens instead",
    rows: 3,
    required: true,
  },
  {
    key: "tried",
    label: "Already tried",
    placeholder: "Steps taken before this session",
    rows: 2,
    required: false,
  },
  {
    key: "errors",
    label: "Errors and logs",
    placeholder: "Paste error messages, event IDs, stack traces",
    rows: 3,
    mono: true,
    required: false,
  },
];

export const EMPTY_CONTEXT = CONTEXT_FIELDS.reduce(
  (acc, field) => ({ ...acc, [field.key]: "" }),
  {}
);

export function contextFromForm(form = {}) {
  return CONTEXT_FIELDS.reduce((acc, field) => {
    const value = String(form[field.key] || "").trim();
    return { ...acc, [field.key]: value || null };
  }, {});
}

export function hasRequiredContext(form = {}) {
  return CONTEXT_FIELDS.filter((field) => field.required).every((field) =>
    String(form[field.key] || "").trim()
  );
}
